import { Navigate } from 'react-router-dom';

import LoadingOverlay from '../../components/common/LoadingOverlay/LoadingOverlay';
import React from 'react';
import { useCapabilityAccess } from '../../hooks/useCapabilityAccess';

interface BetaFeatureGuardProps {
  children: React.ReactNode;
}

const BetaFeatureGuard: React.FC<BetaFeatureGuardProps> = ({ children }) => {
  const access = useCapabilityAccess();

  if (!access.initialized) {
    return <LoadingOverlay visible />;
  }

  if (!access.hasBetaFeatureAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default BetaFeatureGuard;
